import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './MoreMenuContent';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost } from '../../../../redux/deviations/actionCreators';
import { beginDeviationAwardBadgeFlow } from '../../../../coreBadge/redux/actionCreators';
import { focusCommentEditor } from '../../../../DeviationPage/redux/actions';

type StateProps = Pick<Props, 'isOwner'>;
type DispatchProps = Pick<
  Props,
  | 'showReportModal'
  | 'shareDeviationToPost'
  | 'showAwardBadgePopup'
  | 'onCommentClick'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  ownProps
) => ({
  isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  showReportModal,
  shareDeviationToPost,
  showAwardBadgePopup: beginDeviationAwardBadgeFlow,
  onCommentClick: focusCommentEditor,
};

export default connect(mapStateToProps, mapDispatchToProps);
